import __var_0__ from '@stdlib/math/base/special/sqrt';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var sqrt = __var_0__;


// MAIN //

/**
* Returns a pseudorandom number drawn from a triangular distribution with minimum support `a`, maximum support `b` and mode `c`.
*
* @private
* @param {PRNG} rand - PRNG for generating uniformly distributed numbers
* @param {number} a - minimum support
* @param {number} b - maximum support
* @param {number} c - mode
* @returns {number} pseudorandom number
*/
function triangular( rand, a, b, c ) {
	var fc;
	var x;
	var u;
	fc = (c - a) / (b - a);
	u = rand();
	if ( u < fc ) {
		x = (b - a) * (c - a);
		return a + sqrt( x * u );
	}
	x = (b - a) * (b - c);
	return b - sqrt( x * (1.0 - u) );
}


// EXPORTS //
export default triangular;
